function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}import styles from './obd-info-card.scss';
import template from './obd-info-card.html';

export var ObdInfoCardComponent = {
  template: template,
  styles: styles,
  bindings: {
    textCard: '<',
    sTitle: '@',
    description: '@',
    topTextBlue: '@',
    bottomTextBlue: '@',
    textTitle: '@',
    textSubtitle: '@',
    textDescription: '@' },

  transclude: {
    'thumbnail': '?thumbnail' },

  controller:
  function ObdInfoCardComponentController() {
    "ngInject";_classCallCheck(this, ObdInfoCardComponentController);
    console.log(this);
  } };